import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress, Container, Typography } from '@material-ui/core';
import qs from 'query-string';
import { useSelector } from 'react-redux';
import moment from 'moment';
import swal from 'sweetalert';
import UsuarioListResults from '../../components/Usuario/UsuarioListResult';
import UsuarioListToolbar from '../../components/Usuario/UsuarioListToolbar';
import Api from '../../utils/api';

require('moment/locale/pt-br.js'); // eslint-disable-line

const UsuarioList = () => {
  const api = new Api();
  const auth = useSelector((state) => state.auth);
  const { search: searchLocal } = useLocation();
  const query = React.useMemo(() => new URLSearchParams(searchLocal), [searchLocal]);
  const [isLoadingRegs, setIsLoadingRegs] = useState(true);
  const [regs, setRegs] = useState([]);
  const [page, setPage] = useState(query.get('page') !== null ? query.get('page') : 1);
  const [perPage, setPerPage] = useState(query.get('perPage') !== null ? query.get('perPage') : 25);
  const [total, setTotal] = useState(1);
  const [search, setSearch] = useState(query.get('search') !== null ? query.get('search') : '');
  const [orderby, setOrderby] = useState(query.get('orderby') !== null ? query.get('orderby') : 'NOME asc');

  const get = async () => {
    setIsLoadingRegs(true);
    setRegs([]);

    const param = {
      page,
      per_page: perPage,
      filtro: []
    };

    if (search) {
      param.filtro = search;
    }

    if (orderby) {
      param.orderBy = orderby;
    }

    try {
      const { data } = await api.get(`/users?${qs.stringify(param)}`, auth.token);

      // Trata tanto paginação quanto array direto
      if (data.data && Array.isArray(data.data)) {
        // Resposta paginada
        setRegs(data.data);
        setPage(data.page || 1);
        setPerPage(data.perPage || perPage);
        setTotal(data.total || data.data.length);
      } else if (Array.isArray(data)) {
        // Array direto
        setRegs(data);
        setTotal(data.length);
      } else {
        setRegs([]);
        setTotal(0);
      }
    } catch (e) {
      if (process.env.REACT_APP_ENVIROMENT !== 'development') {
        console.error(e);
      }
    } finally {
      setIsLoadingRegs(false);
    }

    return true;
  };

  useEffect(async () => {
    await Promise.all([get()]);
  }, []);

  return (
    <>
      <Helmet>
        <title>{`Parceiros | ${process.env.REACT_APP_TITLE}`}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <UsuarioListToolbar search={search} setSearch={setSearch} query={query} />
          {
            // eslint-disable-next-line no-nested-ternary
            isLoadingRegs ? (
              <Box sx={{ pt: 3 }}>
                <Typography align="center" variant="h5" color="primary">
                  <CircularProgress color="primary" sx={{ mb: 3 }} />
                  <br />
                  Buscando informações, por favor aguarde...
                </Typography>
              </Box>
            ) : !regs ? (
              <Box sx={{ pt: 3 }}>
                <Typography align="center" variant="h5" color="primary">
                  Nenhum registro localizado
                </Typography>
              </Box>
            ) : (
              <Box sx={{ pt: 3 }}>
                <UsuarioListResults
                  regs={regs}
                  setRegs={setRegs}
                  page={page}
                  setPage={setPage}
                  perPage={perPage}
                  setPerPage={setPerPage}
                  total={total}
                  orderby={orderby}
                  setOrderby={setOrderby}
                  query={query}
                />
              </Box>
            )
          }
        </Container>
      </Box>
    </>
  );
};

export default UsuarioList;
